import { defineMessages } from 'react-intl'

export default defineMessages({
  addUser: {
    id: 'OrganizationUsersPage.AddUser',
    defaultMessage: 'Add User(s)'
  },
  addSingleUser: {
    id: 'OrganizationUsersPage.AddSingleUser',
    defaultMessage: 'Add Single User'
  },
  bulkAddUser: {
    id: 'OrganizationUsersPage.Bulk',
    defaultMessage: 'Upload Many Users'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  pageTitle: {
    id: 'OrganizationUsersPage.Title',
    defaultMessage: 'Organization User Management'
  }
})
